export default __webpack_public_path__ + "static/media/delete_employee.71d7f60f.svg";